import { addCommas } from '@/utils';

import { CoinIcon } from '@/components/icons/coin-icon';

export const SabaCoinWithIcon = ({ coin }: { coin: number; }) => {
	return (
		<div className="reward-coin">
			<CoinIcon />
			<div className="reward-coin__text">{addCommas(coin)}</div>
		</div>
	);
};